<app-dialog-header title="Sélection d'un document" />
<div mat-dialog-content class="thin-scrollbar">
  <admin-file-manager #fileManager [documentPicker]="true" [readOnly]="'add'" [selectMode]="true" [type]="type">
  </admin-file-manager>
</div>

<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Annuler</button>
  <button mat-raised-button color="primary" [mat-dialog-close]="fileManager.selection?.selected"
    [disabled]="!fileManager.selection?.hasValue()">Valider</button>
</div>